<template>
  <div id="offside-sale-checkbox">
    <label class="check">
      <input
          class="check-input"
          type="checkbox"
          :value="value"
          :checked="value"
          @change="emitter($event.target.checked)"
      />
      <span class="checkmark checkmark-hd"></span>
      <span class="option-title">{{ label }}</span>
    </label>
  </div>
</template>

<script lang="js">
import '@/styles/checkbox.scss';

export default {
  name: "OffsideSaleCheckbox",
  props: ['value'],
  data() {
    return {
      label: 'นำเสนอขายนอกสถานที่',
    }
  },
  methods: {
    emitter: function (value) {
      this.$emit('input', value)
    }
  }
}
</script>
